import * as React from 'react';
import { SVGProps } from 'react';

const IconSolverMechanicsSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3h12v3h-2v5h2v1h-2v6h2v3H6v-3h2v-6H6v-1h2V6H6V3Zm4 15h4V6h-4v12Z"
      fill="var(--color-control-typo-ghost)"
    />
    <path
      d="M18 15h1.5V6h2v9H23l-2.5 3-2.5-3ZM1 9h1.5v9h2V9H6L3.5 6 1 9Z"
      fill="#91C2A6"
    />
  </svg>
);
export default IconSolverMechanicsSizeM;
